import {DomainObject, oneOf} from 'shared/store';
import _ from 'lodash';
import { observable, computed, makeObservable } from 'mobx';
import PerformanceReviewType from './PerformanceReviewType';
import PerformanceReviewReviewee from './PerformanceReviewReviewee';

class PerformanceReviewCycle extends DomainObject {
  id;
  name;
  state;
  types;
  reviewees;
  submittedReviewsCount;
  pendingReviewsCount;
  totalReviewsCount;
  reviewersCount;
  createdAt;
  completedReviewees;
  startedReviewees;
  launchDate;
  availableInHiring;
  relativeDueDateUnit;
  relativeDueDateValue;
  relativeLaunchDateUnit;
  relativeLaunchDateValue;

  _relations = {
    types: [PerformanceReviewType],
    reviewees: [PerformanceReviewReviewee],
    state: oneOf(['created', 'configured', 'launched', 'ended']),
    _dates: ['createdAt', 'launchDate']
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      name: observable,
      state: observable,
      types: observable,
      reviewees: observable,
      submittedReviewsCount: observable,
      pendingReviewsCount: observable,
      totalReviewsCount: observable,
      reviewersCount: observable,
      createdAt: observable,
      completedReviewees: observable,
      startedReviewees: observable,
      launchDate: observable,
      availableInHiring: observable,
      relativeDueDateUnit: observable,
      relativeDueDateValue: observable,
      relativeLaunchDateUnit: observable,
      relativeLaunchDateValue: observable,
      isLaunched: computed,
      hasEnded: computed,
      managerType: computed,
      selfType: computed,
      peerType: computed,
      directReportType: computed,
      submittedReviewsPercentage: computed,
      pendingReviewsPercentage: computed,
      completedRevieweesPercentage: computed
    });

    this.merge(other);
  }

  get isLaunched() {
    return this.state === 'launched';
  }

  get hasEnded() {
    return this.state === 'ended';
  }

  get managerType() {
    return _.find(this.types, {kind: 'manager'});
  }

  get selfType() {
    return _.find(this.types, {kind: 'self'});
  }

  get peerType() {
    return _.find(this.types, {kind: 'peer'});
  }

  get directReportType() {
    return _.find(this.types, {kind: 'direct_report'});
  }

  get submittedReviewsPercentage() {
    if (this.totalReviewsCount === 0) return 0;

    return _.ceil((this.submittedReviewsCount / this.totalReviewsCount) * 100);
  }

  get pendingReviewsPercentage() {
    if (this.totalReviewsCount === 0) return 0;

    return _.ceil((this.pendingReviewsCount / this.totalReviewsCount) * 100);
  }

  get completedRevieweesPercentage() {
    if (this.reviewees.length === 0) return 100;

    return _.ceil((this.completedReviewees / this.reviewees.length) * 100);
  }
}

export default PerformanceReviewCycle;
